import React from "react";
import { Col, Row } from "reactstrap";
import GovernmentRequests from "./Widgets/GovernmentRequests";
import NumberOfMdas from "./Widgets/NumberOfMdas";
import SalaryScale from "./Widgets/SalaryScale";
import TotalSupport from "./Widgets/TotalSupport";

const Widgets = () => {
  return (
    <React.Fragment>
      <Row className="mt-4">
        <Col xl={3} md={6}>
          <TotalSupport />
        </Col>

        <Col xl={3} md={6}>
          <SalaryScale />
        </Col>

        <Col xl={3} md={6}>
          <NumberOfMdas />
        </Col>

        <Col xl={3} md={6}>
          <GovernmentRequests />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Widgets;
